<template>
  <div class="basic">
    <Form
      ref="formInline"
      :model="formInline"
      style="width: 100%"
      :rules="ruleInline"
      label-position="top"
      @on-validate="getvalidate"
    >
      <div class="basic-header">
        <p>- 企业基本信息 -</p>
      </div>
      <div style="border: solid 1px #e5e5e5; margin-bottom: 30px">
        <!-- 公司名称 -->
        <div class="basic-name">
          <Row :gutter="10">
            <Col span="12">
              <div style="display: flex">
                <FormItem
                  label="企业名称（中文）/ Company Name"
                  prop="companyName"
                >
                  <Input
                    type="text"
                    v-model="formInline.companyName"
                    style="width: 270px; margin-right: 10px"
                    placeholder="请输入企业名称/Please enter Company Name"
                  />
                </FormItem>
                <FormItem label="简称 / Abbreviation" prop="companyNameShort">
                  <Input
                    type="text"
                    placeholder="请输入简称/Please enter Abbreviation"
                    v-model="formInline.companyNameShort"
                    style="width: 270px; margin-right: 10px"
                  />
                </FormItem>
              </div>
            </Col>
            <Col span="12">
              <div style="display: flex">
                <FormItem label="英文名称 / English Name" prop="companyNameEn">
                  <Input
                    type="text"
                    placeholder="请输入英文名称/Please enter English Name"
                    v-model="formInline.companyNameEn"
                    style="width: 270px; margin-right: 10px"
                  />
                </FormItem>
                <FormItem
                  label="统一社会信用代码 / Social credit code"
                  prop="creditCode"
                  id="creditCode"
                >
                  <Input
                    type="text"
                    v-model="formInline.creditCode"
                    style="width: 270px"
                    placeholder="请输入信用代码/Please enter Social credit code"
                  />
                </FormItem>
              </div>
            </Col>
          </Row>
        </div>

        <div class="basic-address">
          <Row :gutter="10">
            <Col span="12">
              <div style="display: flex">
                <FormItem>
                  <div
                    class="ivu-form-item-label"
                    style="position: relative; top: -7px"
                  >
                    <Checkbox v-model="formInline.isBelongChild"
                      >属于子集团公司 / Belong Subsidiaries</Checkbox
                    >
                  </div>
                  <Input
                    type="text"
                    placeholder="请注明母公司名称/Enter parent name"
                    v-model="formInline.parentCompanyName"
                    style="width: 270px; position: relative; top: -8px"
                    :style="{ opacity: formInline.isBelongChild ? 1 : 0 }"
                  />
                </FormItem>
                <FormItem
                  label="网址 / Website"
                  style="position: relative; left: -27px"
                  prop="website"
                >
                  <Input
                    type="text"
                    placeholder="请输入网址/Please enter Website"
                    v-model="formInline.website"
                    style="width: 270px"
                  />
                </FormItem>
              </div>
            </Col>

            <Col span="10">
              <FormItem
                label="企业营业执照 / Company registration certificate"
                required
              >
                <div style="display: flex; position: relative">
                  <Upload
                    ref="upload"
                    :show-upload-list="false"
                    :default-file-list="defaultList"
                    :on-success="handleSuccess"
                    :format="['jpg', 'png']"
                    :max-size="2048"
                    :headers="formHeaders"
                    :on-format-error="handleFormatError"
                    :on-exceeded-size="handleMaxSize"
                    :before-upload="handleBeforeUpload"
                    :action="uploadUrl"
                    style="margin-right: 10px"
                  >
                    <div class="upload-btn">上传 / upload</div>
                  </Upload>
                  <p
                    style="
                      position: absolute;
                      left: 0;
                      top: 34px;
                      font-size: 12px;
                      color: #808080;
                    "
                  >
                    仅支持jpg,png，不超过2M
                  </p>
                  <div class="license-img">
                    <template v-if="uploadList && uploadList.length">
                      <div
                        class="license-img-list"
                        v-for="(item, index) in uploadList"
                        :key="'upload' + index"
                      >
                        <template v-if="item.status === 'finished'">
                          <span
                            class="txt1"
                            :title="item.name"
                            v-if="item.name"
                            >{{ item.name.split(".")[0] }}</span
                          >
                          <span class="line"></span>
                          <span @click="handleRemoveByArr(item)"
                            >删除/delete</span
                          >
                        </template>
                      </div>
                    </template>
                  </div>
                </div>
              </FormItem>
            </Col>
          </Row>
        </div>

        <!-- 公司地址 -->
        <div class="basic-name">
          <Row :gutter="10">
            <Col span="12">
              <FormItem
                label="公司地址 / Company address"
                required
                prop="addresss"
              >
                <div style="width: 550px">
                  <mFormAddress
                    v-model="formInline.addresss"
                    @change="validAddresss"
                  ></mFormAddress>
                </div>
              </FormItem>
            </Col>

            <Col span="10">
              <div style="padding: 0 0 3px 0"></div>
              <div style="display: flex">
                <FormItem
                  prop="address"
                  id="address"
                  label="详细地址 / Detailed address"
                >
                  <Input
                    type="text"
                    placeholder="请输入详细地址/Please enter Detail address"
                    v-model="formInline.address"
                    style="width: 410px; margin-right: 10px"
                  />
                </FormItem>
                <FormItem prop="postcode" id="postcode" label="邮编 / Postcode">
                  <Input
                    type="text"
                    placeholder="邮编/Postcode"
                    v-model="formInline.postcode"
                    style="width: 130px"
                  />
                </FormItem>
              </div>
            </Col>
          </Row>
        </div>
      </div>

      <!-- 展会联系人 -->
      <div class="basic-link">
        <FormItem label="展会联系人 / Contact Person" required> </FormItem>
      </div>
      <div style="border: solid 1px #e5e5e5; margin-bottom: 30px">
        <div class="basic-links">
          <Row :gutter="10">
            <Col span="12">
              <div style="display: flex">
                <FormItem label="姓名 / Name" prop="linkMan">
                  <Input
                    type="text"
                    placeholder="请输入姓名/Please enter Name"
                    v-model="formInline.linkMan"
                    style="width: 270px; margin-right: 10px"
                  />
                </FormItem>
                <FormItem label="职务 / Position" prop="linkTitle">
                  <Input
                    type="text"
                    placeholder="请输入职务/Please enter Position"
                    v-model="formInline.linkTitle"
                    style="width: 270px"
                  />
                </FormItem>
              </div>
            </Col>
            <Col span="12">
              <div style="display: flex">
                <FormItem label="手机 / Tel" prop="linkMob">
                  <Input
                    type="text"
                    placeholder="请输入手机/Please enter Tel"
                    v-model="formInline.linkMob"
                    style="width: 270px; margin-right: 10px"
                  />
                </FormItem>
                <FormItem label="邮箱 / Emai" prop="linkEmail">
                  <Input
                    type="text"
                    placeholder="请输入邮箱/Please enter Email"
                    v-model="formInline.linkEmail"
                    style="width: 270px"
                  />
                </FormItem>
              </div>
            </Col>
          </Row>
          <Row :gutter="10">
            <Col span="12">
              <Row>
                <Col span="12">
                  <FormItem label="座机电话 / Landline" :required="false">
                    <div style="display: flex">
                      <FormItem prop="linkCode">
                        <Input
                          type="number"
                          v-model="formInline.linkCode"
                          style="width: 90px; margin-right: 10px"
                          placeholder="区号/Country code"
                        />
                      </FormItem>
                      一 &nbsp
                      <FormItem prop="linkTelephone">
                        <Input
                          type="number"
                          v-model="formInline.linkTelephone"
                          style="width: 140px; margin-right: 10px"
                          placeholder="电话号码/phone number"
                        />
                      </FormItem>
                    </div>
                    <p
                      style="
                        line-height: 1;
                        font-size: 12px;
                        color: #808080;
                        position: relative;
                        top: -12px;
                      "
                    >
                      示例：010-6343 0880 / Example：010-6343 0880
                    </p>
                  </FormItem>
                </Col>
                <Col span="12">
                  <FormItem
                    label="QQ"
                    prop="linkQQ"
                    style="position: relative; margin-left: -10px"
                  >
                    <Input
                      type="number"
                      placeholder="请输入QQ/Please enter QQ"
                      v-model="formInline.linkQQ"
                      style="width: 270px"
                    />
                  </FormItem>
                </Col>
              </Row>
            </Col>
            <Col span="12">
              <FormItem label="微信 / WeChat" prop="linkWeChat">
                <Input
                  type="text"
                  placeholder="请输入微信/Please enter WeChat"
                  v-model="formInline.linkWeChat"
                  style="width: 270px"
                />
              </FormItem>
            </Col>
          </Row>
        </div>
      </div>

      <!-- 市场部负责人 -->
      <div class="basic-leader">
        <FormItem label="市场部负责人 / Marketing Personnel" required>
        </FormItem>
        <Button @click="copyLinkInfo" class="above" style="left: 370px"
          >Same as above / 信息同步</Button
        >
      </div>

      <div style="border: solid 1px #e5e5e5; margin-bottom: 30px">
        <div class="basic-leaders">
          <Row :gutter="10">
            <Col span="12">
              <div style="display: flex">
                <FormItem label="姓名 / Name" prop="leader">
                  <Input
                    type="text"
                    placeholder="请输入姓名/Please enter Name"
                    v-model="formInline.leader"
                    style="width: 270px; margin-right: 10px"
                  />
                </FormItem>
                <FormItem label="职务 / Position" prop="leaderTitle">
                  <Input
                    type="text"
                    placeholder="请输入职务/Please enter Position"
                    v-model="formInline.leaderTitle"
                    style="width: 270px"
                  />
                </FormItem>
              </div>
            </Col>
            <Col span="12">
              <div style="display: flex">
                <FormItem label="手机 / Tel" prop="leaderMob">
                  <Input
                    type="text"
                    placeholder="请输入手机/Please enter Tel"
                    v-model="formInline.leaderMob"
                    style="width: 270px; margin-right: 10px"
                  />
                </FormItem>
                <FormItem label="邮箱 / Emai" prop="leaderEmail">
                  <Input
                    type="text"
                    placeholder="请输入邮箱/Please enter Email"
                    v-model="formInline.leaderEmail"
                    style="width: 270px"
                  />
                </FormItem>
              </div>
            </Col>
          </Row>
          <Row :gutter="10">
            <Col span="12">
              <Row>
                <Col span="12">
                  <FormItem label="座机电话 / Landline">
                    <div style="display: flex">
                      <FormItem prop="LeaderCode">
                        <Input
                          type="number"
                          v-model="formInline.LeaderCode"
                          style="width: 90px; margin-right: 10px"
                          placeholder="区号/Country code"
                        />
                      </FormItem>
                      一 &nbsp
                      <FormItem prop="leaderTelephone">
                        <Input
                          type="number"
                          v-model="formInline.leaderTelephone"
                          style="width: 140px; margin-right: 10px"
                          placeholder="电话号码/phone number"
                        />
                      </FormItem>
                    </div>
                    <p
                      style="
                        line-height: 1;
                        font-size: 12px;
                        color: #808080;
                        position: relative;
                        top: -12px;
                      "
                    >
                      示例：010-6343 0880 / Example：010-6343 0880
                    </p>
                  </FormItem>
                </Col>
                <Col span="12">
                  <FormItem
                    label="QQ"
                    prop="leaderQQ"
                    style="position: relative; margin-left: -10px"
                  >
                    <Input
                      type="number"
                      placeholder="请输入QQ/Please enter QQ"
                      v-model="formInline.leaderQQ"
                      style="width: 270px"
                    />
                  </FormItem>
                </Col>
              </Row>
            </Col>
            <Col span="12">
              <FormItem label="微信 / WeChat" prop="leaderWeChat">
                <Input
                  type="text"
                  placeholder="请输入微信/Please enter WeChat"
                  v-model="formInline.leaderWeChat"
                  style="width: 270px"
                />
              </FormItem>
            </Col>
          </Row>
        </div>
      </div>

      <!-- 开票信息 -->
      <div class="basic-invoiceType">
        <p style="padding-left: 11px; font-size: 18px">
          VAT Invoice(中国增值税发票)
        </p>
        <Checkbox v-model="isInvoice"
          ><span>暂不填写/No invoice</span></Checkbox
        >
      </div>
      <div style="border: solid 1px #e5e5e5; margin-bottom: 30px">
        <div class="basic-invoices" v-if="!isInvoice">
          <Row :gutter="10">
            <Col span="12">
              <div style="display: flex">
                <FormItem label="发票抬头" prop="invoiceTitle">
                  <Input
                    type="text"
                    placeholder="请输入发票抬头"
                    v-model="formInline.invoiceTitle"
                    style="width: 270px; margin-right: 10px"
                  />
                </FormItem>
                <FormItem label="税号" prop="invoiceCode">
                  <Input
                    type="text"
                    placeholder="请输入税号"
                    v-model="formInline.invoiceCode"
                    style="width: 270px"
                  />
                </FormItem>
              </div>
            </Col>
            <Col span="12">
              <div style="display: flex">
                <FormItem label="单位地址" prop="invoiceAddress">
                  <Input
                    type="text"
                    placeholder="请输入单位地址"
                    v-model="formInline.invoiceAddress"
                    style="width: 270px; margin-right: 10px"
                  />
                </FormItem>
                <FormItem label="电话号码" prop="invoiceTelephone">
                  <Input
                    type="number"
                    placeholder="请输入电话号码"
                    v-model="formInline.invoiceTelephone"
                    style="width: 270px"
                  />
                </FormItem>
              </div>
            </Col>
          </Row>
          <Row :gutter="10">
            <Col span="12">
              <div style="display: flex">
                <FormItem label="开户银行" prop="invoiceBank">
                  <Input
                    type="text"
                    v-model="formInline.invoiceBank"
                    placeholder="请输入开户银行"
                    style="width: 270px; margin-right: 10px"
                  />
                </FormItem>
                <FormItem label="银行账户" prop="invoiceBankAccount">
                  <Input
                    type="text"
                    v-model="formInline.invoiceBankAccount"
                    placeholder="请输入银行账户"
                    style="width: 270px"
                  />
                </FormItem>
              </div>
            </Col>
            <Col span="12">
              <div style="display: flex">
                <FormItem label="开票类型" prop="invoiceType">
                  <RadioGroup v-model="formInline.invoiceType">
                    <Radio label="增值税专票">
                      <span>增值税专用发票</span>
                    </Radio>
                    <Radio label="增值税普票">
                      <span>增值税普通发票</span>
                    </Radio>
                  </RadioGroup>
                </FormItem>
              </div>
            </Col>
          </Row>
          <Row :gutter="10">
            <Col span="12">
              <FormItem
                label="发票邮寄地址"
                required
                prop="invoiceMalingAdresss"
              >
                <div style="width: 550px">
                  <mFormAddress
                    v-model="formInline.invoiceMalingAdresss"
                    @change="MalingAdresssAddresss"
                  ></mFormAddress>
                </div>
              </FormItem>
            </Col>

            <Col span="10">
              <div style="padding: 0 0 3px 0"></div>
              <div style="display: flex">
                <FormItem prop="invoiceMalingAdress" label="详细地址">
                  <Input
                    type="text"
                    placeholder="请输入详细地址"
                    v-model="formInline.invoiceMalingAdress"
                    style="width: 410px; margin-right: 10px"
                  />
                </FormItem>
                <FormItem prop="invoiceMalingCode" label="邮编">
                  <Input
                    type="text"
                    placeholder="请输入邮编"
                    v-model="formInline.invoiceMalingCode"
                    style="width: 130px"
                  />
                </FormItem>
              </div>
            </Col>
          </Row>
          <Row :gutter="10">
            <Col span="12">
              <div style="display: flex">
                <FormItem label="发票收件人" prop="invoiceRecivePerson">
                  <Input
                    type="text"
                    placeholder="请输入发票收件人"
                    v-model="formInline.invoiceRecivePerson"
                    style="width: 270px; margin-right: 10px"
                  />
                </FormItem>
                <FormItem label="收件人电话" prop="invoiceReciveTel">
                  <Input
                    type="number"
                    placeholder="请输入收件人电话"
                    v-model="formInline.invoiceReciveTel"
                    style="width: 270px"
                  />
                </FormItem>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <!-- <div class="handle-box">
        <Button :loading="loading" @click="handleSubmit('formInline')" class="handle-box-btn" type="primary">保存并提交</Button>
      </div> -->
    </Form>
  </div>
</template>

<script>
import mFormAddress from "@components/m-form/m-form-address.vue";
import OSS from "ali-oss";
import config from "@assets/config.json";
import { mapGetters, mapActions } from "vuex";
import { validator } from "@/other/validator";
export default {
  name: "register-form", // 参展申请 - 基本信息
  components: {
    mFormAddress,
  },
  data() {
    const that = this;
    const websiteValid = (rule, value, callback) => {
      if (value) {
        if (/(http|https):\/\/([\w.]+\/?)\S*/.test(value)) {
          callback();
        } else {
          callback("请输入正确的外链地址：https://...");
        }
      } else {
        callback();
      }
    };
    const zhValid = (rule, value, callback) => {
      if (/^[\u4e00-\u9fa5]+$/.test(value)) {
        callback();
      } else {
        callback(new Error("公司名称格式有误"));
      }
    };
    // 判断英文
    const enValid = (rule, value, callback) => {
      if (!value) {
        callback();
      } else {
        if (/^(?!\s*$)[A-Za-z0-9._\-\&\(\)\（）\s-]+$/.test(value)) {
          callback();
        } else {
          callback(new Error("英文名称格式有误"));
        }
      }
    };
    const companyAddressValid = (rule, value, callback) => {
      if (
        that.formInline.addresss.country &&
        that.formInline.addresss.country === "中国"
      ) {
        // 中国 判断省份和城市是否选择
        if (!that.formInline.addresss.province) {
          callback(new Error("省份为空"));
        } else if (!that.formInline.addresss.city) {
          callback(new Error("城市为空"));
        } else {
          callback();
        }
      } else {
        if (that.formInline.addresss.country) {
          callback();
        } else {
          callback(new Error("地址为空"));
        }
      }
    };
    const invoiceAddressValid = (rule, value, callback) => {
      if (that.isInvoice) {
        // 没有发票信息
        callback();
      } else {
        if (
          that.formInline.invoiceMalingAdresss.country &&
          that.formInline.invoiceMalingAdresss.country === "中国"
        ) {
          // 中国 判断省份和城市是否选择
          if (!that.formInline.invoiceMalingAdresss.province) {
            callback(new Error("省份为空"));
          } else if (!that.formInline.invoiceMalingAdresss.city) {
            callback(new Error("城市为空"));
          } else {
            callback();
          }
        } else {
          if (that.formInline.invoiceMalingAdresss.country) {
            callback();
          } else {
            callback(new Error("地址为空"));
          }
        }
      }
    };
    const invoiceTitleValid = (rule, value, callback) => {
      if (that.isInvoice) {
        // 没有发票信息
        callback();
      } else {
        if (!value) {
          callback(new Error("请输入发票抬头"));
        } else {
          callback();
        }
      }
    };
    const invoiceCodeValid = (rule, value, callback) => {
      if (that.isInvoice) {
        // 没有发票信息
        callback();
      } else {
        if (value) {
          if (
            /^[A-Z0-9]{15}$|^[A-Z0-9]{17}$|^[A-Z0-9]{18}$|^[A-Z0-9]{20}$/.test(
              value
            )
          ) {
            callback();
          } else {
            callback("发票税号格式有误");
          }
        } else {
          callback(new Error("请输入发票税号"));
        }
      }
    };
    const invoiceAddValid = (rule, value, callback) => {
      if (that.isInvoice) {
        // 没有发票信息
        callback();
      } else {
        if (!value) {
          callback(new Error("请输入单位地址"));
        } else {
          callback();
        }
      }
    };
    const invoiceTelephoneValid = (rule, value, callback) => {
      if (that.isInvoice) {
        // 没有发票信息
        callback();
      } else {
        if (!value) {
          callback(new Error("请输入单位电话号码"));
        } else {
          callback();
        }
      }
    };
    const invoiceBankValid = (rule, value, callback) => {
      if (that.isInvoice) {
        // 没有发票信息
        callback();
      } else {
        if (!value) {
          callback(new Error("请输入开户银行"));
        } else {
          callback();
        }
      }
    };
    const invoiceBankAccountValid = (rule, value, callback) => {
      if (that.isInvoice) {
        // 没有发票信息
        callback();
      } else {
        if (that.formInline.invoiceType === "增值税专票") {
          if (!value) {
            callback(new Error("请输入银行账号"));
          } else {
            if (/^[0-9]{14,20}$/.test(value)) {
              callback();
            } else {
              callback(new Error("银行账号格式有误"));
            }
          }
        } else {
          if (!value) {
            callback();
          } else {
            if (/^[0-9]{14,20}$/.test(value)) {
              callback();
            } else {
              callback(new Error("银行账号格式有误"));
            }
          }
        }
      }
    };
    const invoiceTypeValid = (rule, value, callback) => {
      if (that.isInvoice) {
        // 没有发票信息
        callback();
      } else {
        if (!value) {
          callback(new Error("请输入发票类型"));
        } else {
          callback();
        }
      }
    };
    const invoiceMalingAdressValid = (rule, value, callback) => {
      if (that.isInvoice) {
        // 没有发票信息
        callback();
      } else {
        if (!value) {
          callback(new Error("请输入详细地址"));
        } else {
          callback();
        }
      }
    };
    const invoiceRecivePersonValid = (rule, value, callback) => {
      if (that.isInvoice) {
        // 没有发票信息
        callback();
      } else {
        if (!value) {
          callback(new Error("请输入发票收件人"));
        } else {
          callback();
        }
      }
    };
    const invoiceReciveTelValid = (rule, value, callback) => {
      if (that.isInvoice) {
        // 没有发票信息
        callback();
      } else {
        if (!value) {
          callback(new Error("请输入收件人电话"));
        } else {
          callback();
        }
      }
    };
    return {
      loading: false,
      isInvoice: false,
      formInline: {
        // 企业基本信息
        companyName: "", // 公司名称
        companyNameShort: "", // 公司简称
        companyNameEn: "", // 公司英文名称
        creditCode: "", // 统一社会信用代码
        address: "", // 详细地址
        addresss: {
          country: "", // 国家
          province: "", // 省份
          city: "", // 城市
          county: "", // 区县
        },
        postcode: "",
        isBelongChild: false, // 是否属于集团子公司
        parentCompanyName: "", // 母公司名称

        // 展会联系人
        linkMan: "",
        linkTitle: "",
        linkTelephone: "",
        linkEmail: "",
        linkCode: "", // 区号
        linkMob: "", // 电话号码
        linkQQ: "",
        linkWeChat: "",

        // 市场部负责人
        leader: "",
        leaderTitle: "",
        leaderTelephone: "",
        leaderEmail: "",
        LeaderCode: "",
        leaderMob: "",
        leaderQQ: "",
        leaderWeChat: "",

        // 开票信息
        invoiceTitle: "",
        invoiceCode: "",
        invoiceAddress: "",
        invoiceTelephone: "",
        invoiceBank: "",
        invoiceBankAccount: "",
        invoiceType: "增值税专票",
        invoiceMalingAdresss: {
          country: "", // 国家
          province: "", // 省份
          city: "", // 城市
          county: "", // 区县
        },
        invoiceMalingAdress: "",
        invoiceMalingCode: "",
        invoiceRecivePerson: "",
        invoiceReciveTel: "",
      },
      formInline1: {
        // 企业基本信息
        companyName: "上海连战技术有限公司", // 公司名称
        companyNameShort: "连战", // 公司简称
        companyNameEn: "lianzhan", // 公司英文名称
        creditCode: "91310118MA1JM12CX7", // 统一社会信用代码
        address: "金沙江西路1555路慧创国际16号2层", // 详细地址
        addresss: {
          country: "中国", // 国家
          province: "上海", // 省份
          city: "嘉定", // 城市
          county: "", // 区县
        },
        postcode: "201803",
        isBelongChild: false, // 是否属于集团子公司
        parentCompanyName: null, // 母公司名称

        // 展会联系人
        linkMan: "李某",
        linkTitle: "技术",
        linkMob: "17630757850",
        linkEmail: "1164232225@qq.com",
        linkCode: "021", // 区号
        linkTelephone: "8888888", // 电话号码
        linkQQ: "2624006658",
        linkWeChat: "xiansheng",

        // 市场部负责人
        leader: "王二",
        leaderTitle: "市场",
        leaderMob: "13122959677",
        leaderEmail: "1164232225@qq.com",
        LeaderCode: "021",
        leaderTelephone: "8888888",
        leaderQQ: "17630757850",
        leaderWeChat: "wanger",

        // 开票信息
        invoiceTitle: "慕渊（上海）智能科技有限公司",
        invoiceCode: "91310118MA1JM12CX7",
        invoiceAddress: "上海上海市嘉定区江桥镇金沙江西路1555路慧创国际16号2层",
        invoiceTelephone: "13122959676",
        invoiceBank: "6214837922727635",
        invoiceBankAccount: "12345678963251254",
        invoiceType: "增值税专票",
        invoiceMalingAdresss: {
          country: "中国", // 国家
          province: "上海", // 省份
          city: "嘉定", // 城市
          county: "", // 区县
        },
        invoiceMalingAdress: "江桥镇金沙江西路1555路慧创国际16号2层",
        invoiceMalingCode: "201803",
        invoiceRecivePerson: "王二",
        invoiceReciveTel: "17630757850",
      },
      ruleInline: {
        // 企业基本信息
        companyName: [
          {
            required: true,
            message: "请输入企业名称（中文）/ Company Name",
            trigger: "blur",
          },
          // { validator: zhValid, trigger: "blur" }
        ],
        companyNameShort: [
          {
            type: "string",
            min: 2,
            max: 4,
            message: "公司简称长度在2到4个字符",
            trigger: "blur",
          },
        ],
        companyNameEn: [{ validator: enValid, trigger: "blur" }],
        website: [{ validator: websiteValid, trigger: "blur" }],
        // companyNameShort: [
        //   {
        //     // required: true,
        //     min: 2,
        //     max: 20,
        //     message: "公司简称长度在2到4个字符",
        //     trigger: ["change", "blur"],
        //   },
        //   { required: true, message: "请输入公司简称", trigger: "blur" },
        // ],
        creditCode: [
          {
            required: true,
            message: "请输入信用代码/Please enter Social credit code",
            trigger: "blur",
          },
          ...validator.CreditCode,
        ],
        addresss: [
          {
            required: true,
            validator: companyAddressValid,
            trigger: "change",
          },
        ],
        address: [
          {
            required: true,
            message: "请输入详细地址/Please enter Detail address",
            trigger: "blur",
          },
        ],

        // 展会联系人
        linkMan: [
          {
            required: true,
            message: "请输入姓名/Please enter Name",
            trigger: "blur",
          },
        ],
        linkTitle: [
          {
            required: true,
            message: "请输入职务/Please enter Position",
            trigger: "blur",
          },
        ],
        linkMob: [
          {
            required: true,
            message: "请输入手机/Please enter Tel",
            trigger: "blur",
          },
          ...validator.phone,
        ],
        linkEmail: validator.email,

        // 市场部负责人
        leader: [
          {
            required: true,
            message: "请输入姓名/Please enter Name",
            trigger: "blur",
          },
        ],
        leaderTitle: [
          {
            required: true,
            message: "请输入职务/Please enter Position",
            trigger: "blur",
          },
        ],
        leaderMob: [
          {
            required: true,
            message: "请输入手机/Please enter Tel",
            trigger: "blur",
          },
          ...validator.phone,
        ],
        leaderEmail: validator.email,

        // 开票信息
        invoiceTitle: [
          { required: true, validator: invoiceTitleValid, trigger: "blur" },
        ],
        invoiceCode: [
          { required: true, validator: invoiceCodeValid, trigger: "blur" },
        ],
        invoiceAddress: [
          { required: true, validator: invoiceAddValid, trigger: "change" },
        ],
        invoiceTelephone: [
          { required: true, validator: invoiceTelephoneValid, trigger: "blur" },
        ],
        invoiceBank: [
          { required: true, validator: invoiceBankValid, trigger: "blur" },
        ],
        invoiceBankAccount: [
          {
            required: true,
            validator: invoiceBankAccountValid,
            trigger: "blur",
          },
        ],
        invoiceType: [
          { required: true, validator: invoiceTypeValid, trigger: "blur" },
        ],
        invoiceMalingAdresss: [
          {
            required: true,
            validator: invoiceAddressValid,
            trigger: "blur",
          },
        ],
        invoiceMalingAdress: [
          {
            required: true,
            validator: invoiceMalingAdressValid,
            trigger: "blur",
          },
        ],
        invoiceRecivePerson: [
          {
            required: true,
            validator: invoiceRecivePersonValid,
            trigger: "blur",
          },
        ],
        invoiceReciveTel: [
          { required: true, validator: invoiceReciveTelValid, trigger: "blur" },
        ],
      },
      defaultList: [],
      uploadList: [],
      //   uploadList: ['https://synairsoft.obs.cn-north-4.myhuaweicloud.com/cloudExhibition/imgs/202304/ec3303b80ba848ecb4a8d8d859bacf11.jpg'],
      uploadName: "",

      isExport: true, // 是否是外销企业
      isListed: true, // 是否是上市公司
      isTop500: true, // 是否是世界五百强
      isMicroEnterprise: true, // 是否为小微企业
      isHighTech: true, // 是否为高新技术企业

      basicInfo: null,
      validateList: [],
      ElepropName: "", //验证错误的prop名
      companyId: "", //公司ID
      isOption: true, //企业经营类型是否是选择框

      countryList: [],
      provinceArr: [],
      citiesArr: [],
    };
  },
  computed: {
    ...mapGetters({
      formHeaders: "getFormHeaders",
      uploadUrl: "getUploadUrl",
      exhibitionId: "getExhibitionId",
      company: "getCompany",
    }),
    userId() {
      return this.$route.query.userId;
    },
    applyCompanyId() {
      return this.$route.query.applyCompanyId;
    },
    applyCompanyOrderId() {
      return this.$route.query.applyCompanyOrderId;
    },
  },
  mounted() {
    console.log(this.uploadUrl, "uploadUrl");
  },
  methods: {
    ...mapActions({
      getCityByParentId: "exhibitionModule/getCityByParentId",
      addApplyCompany: "addApplyCompany",
      editApplyCompany: "editApplyCompany",
    }),
    getvalidate(prop, status, error) {
      console.log("getvalidate", prop, status, error);
      if (status == false) {
        let opt = {
          prop: prop,
          status: status,
          error: error,
        };
        this.validateList.push(opt);
      }
    },
    deteleObject(obj) {
      var uniques = [];
      var stringify = {};
      for (var i = 0; i < obj.length; i++) {
        var keys = Object.keys(obj[i]);
        keys.sort(function (a, b) {
          return Number(a) - Number(b);
        });
        var str = "";
        for (var j = 0; j < keys.length; j++) {
          str += JSON.stringify(keys[j]);
          str += JSON.stringify(obj[i][keys[j]]);
        }
        if (!stringify.hasOwnProperty(str)) {
          uniques.push(obj[i]);
          stringify[str] = true;
        }
      }
      uniques = uniques;
      return uniques;
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate((valid) => {
          console.log(valid, "valid");
          resolve(valid);
        });
      });
    },
    handleSuccess(res, file) {
      console.log(res, "uploadUrl", this.uploadName, file);
      if (res) {
        this.uploadList.push({
          name: this.uploadName,
          url: res.cdnBaseUrl + "/" + res.path,
          status: "finished",
        });
      } else {
        this.uploadName = "";
      }
    },
    handleFormatError(file) {
      this.uploadName = "";
      this.$Notice.warning({
        title: "文件格式是不正确的",
        desc: "请上传jpg或者png格式的图片",
      });
    },
    handleMaxSize(file) {
      this.uploadName = "";
      this.$Notice.warning({
        title: "文件大小超过限制",
        desc: "请上传小于2M的图片",
      });
    },
    handleBeforeUpload(e) {
      this.uploadName = e.name;
      const limitNum = 1;
      const check = this.uploadList.length < limitNum;
      if (!check) {
        this.$Notice.warning({
          title: `最多上传${limitNum}张图片`,
        });
      }
      return check;
    },
    handleRemoveByArr(file) {
      const fileList = this.uploadList;
      this.uploadList.splice(fileList.indexOf(file), 1);
    },
    addAreaArr() {
      if (this.formInline.exportSalesArea.length > 4) {
        this.$Message.warning("最多可选五个");
        return;
      }
      this.formInline.exportSalesArea.push([]);
    },
    delAreaArr(i) {
      this.formInline.exportSalesArea.splice(i, 1);
    },
    //资产类型选择框变更
    getselect(value) {
      console.log(value, "类型");
      if (value === "其他") {
        this.isOption = false;
      } else {
        this.isOption = true;
      }
    },
    //同上按钮
    copyLinkInfo() {
      this.formInline.leader = this.formInline.linkMan;
      this.formInline.leaderTitle = this.formInline.linkTitle;
      this.formInline.leaderTelephone = this.formInline.linkTelephone;
      this.formInline.leaderEmail = this.formInline.linkEmail;
      this.formInline.LeaderCode = this.formInline.linkCode;
      this.formInline.leaderMob = this.formInline.linkMob;
      this.formInline.leaderQQ = this.formInline.linkQQ;
      this.formInline.leaderWeChat = this.formInline.linkWeChat;
    },
    async handleSubmit(name) {
      let form = this.formInline;
      let valid = await this.validForm("formInline");
      let errTxt = "";
      if (!valid) {
        errTxt = this.validateList[0]
          ? this.validateList[0].error
          : "请完善表单";
      }
      // 营业执照
      let imgBusinessLicense = "";
      if (this.uploadList && this.uploadList.length) {
        imgBusinessLicense = this.uploadList[0].url;
      } else {
        errTxt = "请上传营业执照";
        valid = false;
      }
      if (errTxt) {
        this.$Message.error(errTxt);
        this.validateList = [];
      }
      console.log("form", this.formInline);
      let formValue = {
        website: form.website, // 公司名称
        companyName: form.companyName, // 公司名称
        companyNameShort: form.companyNameShort, // 公司简称
        companyNameEn: form.companyNameEn, // 公司英文名称
        unifiedCode: form.creditCode, // 统一社会信用代码
        address: form.address, // 详细地址
        country: form.addresss.country,
        province: form.addresss.province,
        city: form.addresss.city,

        postcode: form.postcode,
        isBelongChild: form.isBelongChild, // 是否属于集团子公司
        parentCompanyName: form.parentCompanyName, // 母公司名称

        // 展会联系人
        linkMan: form.linkMan,
        linkTitle: form.linkTitle,
        linkTelephone: form.linkTelephone,
        linkEmail: form.linkEmail,
        linkCode: form.linkCode, // 区号
        linkMob: form.linkMob, // 电话号码
        linkQQ: form.linkQQ,
        linkWeChat: form.linkWeChat,

        // 市场部负责人
        leader: form.leader,
        leaderTitle: form.leaderTitle,
        leaderTelephone: form.leaderTelephone,
        leaderEmail: form.leaderEmail,
        LeaderCode: form.LeaderCode,
        leaderMob: form.leaderMob,
        leaderQQ: form.leaderQQ,
        leaderWeChat: form.leaderWeChat,

        // 开票信息
        invoiceTitle: form.invoiceTitle,
        invoiceCode: form.invoiceCode,
        invoiceAddress: form.invoiceAddress,
        invoiceTelephone: form.invoiceTelephone,
        invoiceBank: form.invoiceBank,
        invoiceBankAccount: form.invoiceBankAccount,
        invoiceType: form.invoiceType,

        invoiceMalingCountry: form.invoiceMalingAdresss.country,
        invoiceMalingProvince: form.invoiceMalingAdresss.province,
        invoiceMalingCity: form.invoiceMalingAdresss.city,

        invoiceMalingAdress: form.invoiceMalingAdress,
        invoiceMalingCode: form.invoiceMalingCode,
        invoiceRecivePerson: form.invoiceRecivePerson,
        invoiceReciveTel: form.invoiceReciveTel,
        // imgBusinessLicense: JSON.stringify({ name: "", url: imgBusinessLicense }),
        imgBusinessLicense: JSON.stringify({
          name: "",
          url: imgBusinessLicense,
        }),
      };
      return new Promise((resolve, reject) => {
        resolve({ valid: valid, form: formValue });
      });
    },
    validAddresss() {
      // this.$refs['formInline'].validateField('addresss', (valid) => {
      //   console.log("addresss", valid);
      // });
    },
    MalingAdresssAddresss() {
      // this.$refs['formInline'].validateField('invoiceMalingAdresss', (valid) => {
      //   console.log("addresss", valid);
      // });
    },
  },
};
</script>

<style scoped lang='scss'>
.basic {
  /deep/ {
    .ivu-checkbox-checked .ivu-checkbox-inner {
      border-color: #00a0e9;
      background-color: #00a0e9;
    }
    .ivu-upload-select {
      display: flex;
    }
    .ivu-radio-checked .ivu-radio-inner {
      border-color: #00a0e9 !important;
    }
    .ivu-radio-inner:after {
      background-color: #00a0e9;
    }
    .ivu-switch-checked {
      border-color: #00a0e9;
      background-color: #00a0e9;
    }
  }
  &-header {
    width: 100%;
    height: 64px;
    background-color: #00a0e9;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    p {
      line-height: 64px;
      font-size: 20px;
    }
    span {
      width: 30px;
      height: 1px;
      background-color: #fff;
      margin: 0 15px;
    }
  }

  &-name {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-address {
    padding: 30px 0 10px 30px;
    background-color: #ededed;
  }

  &-phone {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-license {
    padding: 30px 0 10px 30px;
    background-color: #ededed;
  }

  .upload-btn {
    width: 180px;
    height: 32px;
    background-color: #fff;
    text-align: center;
    cursor: pointer;
  }
  .license-img {
    display: flex;
    flex-wrap: wrap;
    &-list {
      line-height: 32px;
      padding: 0 10px;
      background-color: #fff;
      display: flex;
      align-items: center;
      margin-right: 10px;
      margin-bottom: 10px;
      .txt1 {
        // width: 200px;
        display: inline-block;
        height: 32px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #515a6e !important;
      }
      span {
        color: #00a0e9;
        cursor: pointer;
      }
      .line {
        width: 1px;
        height: 24px;
        background-color: #e6e6e6;
        margin: 0 6px;
      }
    }
  }

  &-export {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-scale {
    padding: 30px 0 10px 30px;
    background-color: #ededed;
  }

  &-tech {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-link {
    padding: 0 30px;
    background-color: #ededed;
    .ivu-form-item {
      margin-bottom: 0;
      line-height: 48px;
      /deep/ .ivu-form-item-label {
        font-size: 18px;
        padding: 0;
      }
    }
  }

  &-links {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-leader {
    padding: 0 30px;
    background-color: #ededed;
    position: relative;
    .ivu-form-item {
      margin-bottom: 0;
      line-height: 48px;
      /deep/ .ivu-form-item-label {
        font-size: 18px;
        padding: 0;
      }
    }
    .above {
      position: absolute;
      left: 240px;
      top: 10px;
    }
  }

  &-leaders {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-invoiceType {
    padding: 0 30px;
    background-color: #ededed;
    line-height: 48px;
    display: flex;
    justify-content: space-between;
    .ivu-checkbox-wrapper {
      margin: 0;
    }
    span {
      color: #ff0000;
      margin-left: 5px;
    }
  }

  &-invoices {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }
}
</style>
